import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

interface IProps {
  text: string;
  style?: any;
  multiline?: boolean;
  disableUnderline?: boolean;
  fullWidth?: boolean;
  label?: string;
  id?: string;
  disabled?: boolean;
  onCopy?(text: string, result: boolean): void;
}

interface IState {
  copied: boolean;
  tooltipOpen: boolean;
  tooltipText: string;
}

class CustomCopyToClipboard extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      copied: false,
      tooltipOpen: false,
      tooltipText: 'Copiar',
    };
  }

  handleTooltipClose = () => {
    this.setState({ tooltipOpen: false });
  };

  handleTooltipOpen = () => {
    this.setState({ tooltipOpen: true });
  };

  handleCopy = (text: string, result: boolean) => {
    this.setState({ copied: true, tooltipOpen: true, tooltipText: 'Copiado!' });

    if (this.props.onCopy) {
      this.props.onCopy(text, result);
    }

    setTimeout(() => {
      this.setState({ copied: false, tooltipOpen: false, tooltipText: 'Copiar' });
    }, 3000);
  };

  render() {
    const propsInput = {
      fullWidth: true,
      endAdornment: (
        <Tooltip
          title={this.state.tooltipText}
          open={this.state.tooltipOpen}
          onClose={this.handleTooltipClose}
          onOpen={this.handleTooltipOpen}
          placement='top'
        >
          <InputAdornment position='end' variant='filled' disablePointerEvents={this.props.disabled}>
            <CopyToClipboard text={this.props.text} onCopy={this.handleCopy}>
              <IconButton>
                <Icon style={{ color: '#596375' }}>content_copy</Icon>
              </IconButton>
            </CopyToClipboard>
          </InputAdornment>
        </Tooltip>
      ),
      disableUnderline: this.props.disableUnderline,
      label: this.props.label,
    };

    return (
      <TextField
        id={this.props.id}
        label={this.props.label}
        style={this.props.style}
        value={this.props.text}
        InputProps={propsInput}
        fullWidth={this.props.fullWidth}
        multiline={this.props.multiline}
        disabled={this.props.disabled}
      />
    );
  }
}

export default CustomCopyToClipboard;
